import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import bgImg from "../assets/bg.png";
import Sidebar from "./Sidebar";
import Main from "./Main";
import DashboardPage from "./Dashboard/Dashboard";

const SigninPage = () => {
    return (
        <Container>
            <Wrapper>
                <Sidebar />
                <Main />
            </Wrapper>
        </Container>
    );
};

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<SigninPage />} />
                <Route path="/signin" element={<SigninPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
            </Routes>
        </Router>
    );
};

const Container = styled.div`
    background: #eefcff;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;
const Wrapper = styled.div`
    background-image: url(${bgImg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    display: flex;
`;

export default App;
